import type { ReactNode } from 'react'

import { Box, Typography } from '@mui/material'

type ArticleResourceRowProps = {
  actions: ReactNode
  children: ReactNode
}

type ArticleResourceNameProps = {
  children: ReactNode
}

export function ArticleResourceRow({ actions, children }: ArticleResourceRowProps) {
  return (
    <Box
      sx={{
        border: '1px solid #d8e0ea',
        borderRadius: 1.5,
        p: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 13,
        gap: 1,
      }}
    >
      {children}
      {actions}
    </Box>
  )
}

export function ArticleResourceName({ children }: ArticleResourceNameProps) {
  return (
    <Typography
      variant="body2"
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Typography>
  )
}
